import React, {
    ReactElement, useEffect, useState,
} from "react";
import { GrFormClose } from "react-icons/gr";
import useRouting, { Link } from "../../../contexts/Routing";
import useSelectionState from "../../../pages/agent/selection-state";
import Styles from "./LatestConversations.module.scss";

const KEY = "latest-conversations";

const STORE_LAST = 20;
export default function LatestConversations({ displayCount }: {displayCount: number}): ReactElement | null {
    const { Paths } = useRouting();
    const selectionState = useSelectionState();
    const [selected, setSelected] = useState<string[]>(() => {
        try {
            return JSON.parse(localStorage.getItem(KEY) ?? "[]").filterNull();
        } catch (err) {
            localStorage.setItem(KEY, JSON.stringify([]));
            return [];
        }
    });
    useEffect(() => {
        if (selected) {
            localStorage.setItem(KEY, JSON.stringify(selected));
        }
    }, [selected]);
    selectionState.registerOpenedHandler(id => {
        setSelected(current =>
            // eslint-disable-next-line implicit-arrow-linebreak
            current.filter(item => item !== id).dedupe().concat([id]).last(STORE_LAST));
    });
    const tickets = selectionState.getChats(selected.last(displayCount));
    if (!tickets) {
        return null;
    }

    const onClose = (id: string) => {
        setSelected(current =>
            // eslint-disable-next-line implicit-arrow-linebreak
            current.filter(item => item !== id).dedupe().last(STORE_LAST));
    };
    return (
        <div className={` d-flex justify-content-end pe-2 ${Styles["fixed-bottom-right"]}`}>
            <ul className="list-group list-group-horizontal">
                {tickets.map(ticket => {
                    const isNotification = selectionState.isUnread(ticket.id);
                    return (
                        <div
                            className={
                                `d-flex align-items-start border py-1 px-2 me-2 rounded-top border-gray-400 shadow ${
                                    isNotification ? "bg-blue-dark " : "bg-white"}`
                            }
                            key={`latest-convo-${ticket.id}`}
                        >
                            <Link
                                to={Paths.AGENT_CHAT}
                                params={{ chatId: ticket.ticketNumber ?? ticket.id }}
                                className={`${isNotification ? "link-white" : "link-primary"} text-decoration-none me-2
                                        ${Styles["latest-item"]}`}
                            >
                                <div>
                                    {ticket.ticketNumber && (
                                        <small className="text-gray-500 me-1">
                                            #
                                            {ticket.ticketNumber}
                                        </small>
                                    )}
                                    {ticket.subject}
                                </div>
                                <small className="text-gray-500">
                                    {ticket.creator.name}
                                    {" "}
                                    |
                                    {" "}
                                    {ticket.creator.group}
                                </small>

                            </Link>
                            <button
                                type="button"
                                className="btn btn-none p-0"
                                aria-label="Close"
                                onClick={() => onClose(ticket.id)}
                            >
                                <GrFormClose />
                            </button>
                        </div>

                    );
                })}
            </ul>
        </div>
    );
}
